import React from "react";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { deleteCDocFolder } from "../Actions/ControlledDocAPI";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import { confirmAlert } from "react-confirm-alert";
import { OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";

class ControlledDocCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first: 0,
        };
    }

    // deleteFolder(item) {
    //     const { t } = this.props;
    //     confirmAlert({
    //         message: `${t("confirmAlertMessage.DeleteMsg")}`,
    //         buttons: [
    //             {
    //                 label: `${t("confirmAlertMessage.Yes")}`,
    //                 onClick: () => {
    //                     const { dispatch } = this.props;
    //                     dispatch(deleteCDocFolder(item));
    //                 }
    //             },
    //             {
    //                 label: `${t("confirmAlertMessage.No")}`,
    //                 onClick: () => { }
    //             }
    //         ]
    //     });
    // }

    renderedit(props) {
        return (
          <Popover id="history-tooltip" {...props}>
            <Popover.Content>
              <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
            </Popover.Content>
          </Popover>
        );
      }

      renderdelete(props) {
        return (
          <Popover id="history-tooltip" {...props}>
            <Popover.Content>
              <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
            </Popover.Content>
          </Popover>
        );
      }

    render() {
        const { arraylist,currentPage, pageSize, totalRecords, t } = this.props;
        return (
            <div className="pb-3">
                {this.renderCardData()}
                {arraylist?.length != 0 ? (
                    <Paginator
                        first={currentPage}
                        rows={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={(e) => this.onPaginatorChange(e)}
                    ></Paginator>
                ) : (
                    <div
                        className="card"
                        style={{ overflow: "hidden", position: "relative" }}
                    >
                        <div className="container">
                            <h6 className="resource-list-title no-item-card">
                                !--{t("CommonText.NoItem")}--!
                            </h6>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    onPaginatorChange(event) {
        this.setState({
            first: event.first,
        });
        const { setUpdatedState } = this.props;
        setUpdatedState(event.page + 1);
    }

    renderCardData = () => {
        const { showSidePane, arraylist, eyeclick, t,deleteFolder } = this.props;
        const isArabic = i18n.language === 'arab'
        // console.log("Arraylist[]", arraylist)
        return arraylist && arraylist.length
            ? arraylist.map((item, index) => {
                return (
                    <div className="card mb-2" style={{ overflow: "hidden", position: "relative" }}>
                        <div className="p-2">
                            <div className="resource-list-auth-date">
                                <div className="row">
                                    <div className="col-sm-9 col-md-10 col-9 m-auto">
                                        <div className="row px-4">
                                            <div className="col-sm-6 mb-1">
                                                <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                                    <strong>{t("ControlledDocumentsScreenContent.Folder")}  </strong>
                                                    <strong>:</strong>
                                                    
                                                </span>
                                                <span className="italicFont ">{item.folderName}</span>
                                            </div>

                                            <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-6"}>
                                                <span className={`${isArabic ? 'arabic' : ''}`}>
                                                    <strong>{t("ControlledDocumentsScreenContent.NoofDocuments")}  </strong>
                                                    <strong>:</strong>
                                                    <span className="italicFont ">{item.noOfFiles} </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"col-sm-3 col-md-2 col-3 m-auto text-right"}>
                                        <div className={"text-center"}>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderedit()}
                                            >
                                                <i className="fa fa-eye click m-2" aria-hidden="true" onClick={() => eyeclick(item)} style={{ color: ' #1a3464', fontSize: "1.8rem" }} ></i>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="bottom"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={this.renderdelete()}
                                            >
                                            <i className="fa fa-trash click m-2" aria-hidden="true" onClick={() => deleteFolder(item)} style={{ color: ' #1a3464', fontSize: "1.8rem" }} ></i>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
            : null;
    };
    DownloadDoc(attachmentName, attachmentGuid) {
        this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
    }
}

function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default withTranslation()(withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ControlledDocCard)));
